const FormEndpoint = {
  GET: '/cmms/work-order-form/get',
  REMOVE: '/cmms/work-order-form/remove',
  LIST: '/cmms/work-order-form/list',
  LIST_BY_WORK_ORDERS: '/cmms/work-order-form/list-by-work-orders',
  TEMPLATES_BY_PARTNER: '/cmms/work-order-form-template/list-by-partner',
  CREATE_TEMPLATE: '/cmms/work-order-form-template/create',
  UPDATE_TEMPLATE: '/cmms/work-order-form-template/update',
  REMOVE_TEMPLATE: '/cmms/work-order-form-template/remove',
};

export default FormEndpoint;
